import {PriceApiDto} from "../../api/model/rest";
import JsonConverter from "../../api/helper/JsonConverter";

/**
 * Price.
 */
export default class Price {
	constructor(public readonly amount: number,
		public readonly currency: CurrencyIsoCode) {}

	static fromJson(json: PriceApiDto): Price {
		return new Price(json.amount, CurrencyIsoCode[json.currency]);
	}

	toJson(): PriceApiDto {
		const json: PriceApiDto = {
			amount: this.amount,
			currency: this.currency
		};
		return JsonConverter.removeEmptyFields(json);
	}

	/**
	 * Format price to display with currency
	 */
	format(): string {
		return `${CurrencySymbol[this.currency]}${this.amount.toLocaleString("en", {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
	}
}

export enum CurrencyIsoCode {
	GBP = "GBP"
}

export enum CurrencySymbol {
	GBP = "£"
}